<template>
    <div :class="theme.wrapper" @click="handleOpen" @mouseleave="handleBlur" @mouseenter="handleFocus">
        <slot></slot>
        <transition name="fade" :enter-active-class="theme.fadeEnterActive" :enter-class="theme.fadeEnter" :enter-to-class="theme.fadeEnterTo" :leave-active-class="theme.fadeLeaveActive" :leave-class="theme.fadeLeave" :leave-to-class="theme.fadeLeaveTo">
            <div v-if="isOpen" :class="theme.dropdown">
                <div :class="theme.dropdownContainer">
                    <v-dropdown-raw :items="items" @select="$emit('select', $event)">
                        <template slot="item" scope="props">
                            <slot name="item" :item="props.item">
                                {{ props.item }}
                            </slot>
                        </template>
                    </v-dropdown-raw>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
    import vDropdownRaw from './DropdownRaw';
    import theme from './dropdown.scss';

    export default {
        name: 'dropdown',
        props: {
            items: [Object, Array],
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            }
        },
        components: {
            vDropdownRaw,
        },
        data() {
            return {
                isActive: false,
                isOpen: false,
            }
        },
        created() {
            window.addEventListener('click', this.handleClose);
        },
        destroyed() {
            window.removeEventListener('click', this.handleClose);
        },
        methods: {
            handleClose() {
                if (!this.isActive) {
                    this.isOpen = false;
                }
            },
            handleOpen() {
                this.isOpen = !this.isOpen;
            },
            handleFocus() {
                this.isActive = true;
            },
            handleBlur() {
                // isOpen: false, // autohide
                this.isActive = false;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Dropdown.vue?96c0470e